import { useState } from "react";
import { Drawer, DrawerProps, Portal, styled, useTheme } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { StyledCollapseDrawerButton } from "components/buttons/StyledCollapseDrawerButton";

interface Props extends DrawerProps {
  onToggle: () => void;
  hideToggle?: boolean;
  padding?: number;
  paddingTopBottom?: number;
  paddingLeftRight?: number;
}

export function CollapsibeDrawer(props: Props) {
  const {
    children,
    open,
    hideToggle = false,
    onToggle,
    anchor,
    padding = 2,
    paddingTopBottom,
    paddingLeftRight,
    ...drawerProps
  } = props;
  const [paperRef, setPaperRef] = useState<HTMLDivElement | null>(null);
  const theme = useTheme();

  return (
    <StyledDrawer
      ref={(ref) => setPaperRef(ref)}
      open={open}
      anchor={anchor}
      PaperProps={{
        elevation: 0,
        sx: {
          maxHeight: `${paperRef ? paperRef.clientHeight : `10vh`}`,
          padding: theme.spacing(
            paddingTopBottom || padding,
            paddingLeftRight || padding
          ),
        },
      }}
      {...drawerProps}
    >
      {children}
      {!hideToggle && (
        <Portal container={paperRef}>
          <StyledCollapseDrawerButton
            onClick={onToggle}
            className={`toggle-button ${anchor || "left"} ${
              open ? "open" : "closed"
            }`}
          >
            <ArrowBack />
          </StyledCollapseDrawerButton>
        </Portal>
      )}
    </StyledDrawer>
  );
}

const StyledDrawer = styled(Drawer)`
  position: relative;
  display: flex;
  &:not(.closed) {
    & > .MuiPaper-root {
      position: absolute;
      width: 100%;

      flex: 1 1 100%;
    }
  }

  & > .toggle-button {
    z-index: ${({ theme }) => theme.zIndex.drawer + 1};
    background-color: ${({ theme }) => theme.palette.background.paper};
    position: absolute;
    right: -10px;
    top: 50%;
    & > .MuiSvgIcon-root {
      transition: transform 320ms ease-in-out;
    }

    &.right {
      right: unset;
      left: -10px;

      & > .MuiSvgIcon-root {
        transform: rotate(180deg);
      }
      &.closed {
        left: -22px;
        & > .MuiSvgIcon-root {
          transform: rotate(0deg);
        }
      }
    }
    &.closed {
      transition: background-color 500ms ease-in-out;
      background-color: ${({ theme }) => theme.palette.primary.main};
      color: ${({ theme }) => theme.palette.primary.contrastText};
      box-shadow: ${({ theme }) => theme.shadows[3]};
      &.left {
        right: -22px;
      }
      & > .MuiSvgIcon-root {
        transform: rotate(180deg);
      }
    }
    transform: translateY(-50%);
  }
`;
